<template>
  <div>
    <vx-card class="relative">
      <div>
        <vs-row vs-w="12" class="mb-5">
          <vs-col vs-lg="1" vs-sm="4" vs-xs="12">
            <vs-button @click="goBack" color="primary" type="border">Back</vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="4" vs-xs="12">
            <h3>{{ campaignDescription.campaign_name }} Contacts</h3>
          </vs-col>
        

          <vs-col vs-lg="2" vs-sm="4" vs-xs="12">
            <!-- <vs-button type="filled"
              @click="campaignDataOptions">Campaign Data Options</vs-button> -->
          </vs-col>

          <vs-col vs-lg="2" vs-sm="4" vs-xs="12">
            <!-- <vs-button type="filled"
            @click="campaignDataOptions">Campaign Data Options</vs-button> -->
            <!-- <vs-button color="primary" type="filled"
              @click="updateOtherFieldDataToMasterDb">Import None Core Fields</vs-button> -->
          </vs-col>

          


          <vs-col vs-lg="1" vs-sm="4" vs-xs="12">
            <vs-button :color="acceptButtonColor" type="filled"
              @click="acceptSelected">Accept</vs-button>


              <input
              type="checkbox"
              v-model="allSelected"
              style="float:right;"
              @click="selectAll"
            />
          </vs-col>
        </vs-row>
      </div>
    </vx-card>

    <progress-bar bar-color="grey" :val="uploadPercentage" :text="PLeasewait"></progress-bar>

    <vx-card class="vxtable">


     <h3>{{  'Total : ' +  this.all_total}}</h3> 
      <vs-pagination :total="total_pages" v-model="currentx" goto></vs-pagination>
      <template v-for="(unmatched_contact, key) in unmatch_contacts">
       
        <vs-table stripe :data="unmatched_contact" class="mb-20">
          <template slot="header">
            <h5></h5>
            <!-- {{combined_matches}} -->
            <div class="row">

              <UnmatchedContactAutocomplete
              :unmatched_contact="unmatched_contact"
              @update-accepted-id="acceptedIds"
              @update-rejected-id="rejectedIds"
              :selectedSlave="unmatched_contact.id"
              :campaignId="campaignId"
              class="searchbox"
              :key="componentKey"
              :combined_matches="combined_matches"
            ></UnmatchedContactAutocomplete>


              <!-- <Autocomplete :unmatched_contact="unmatched_contact" @update-accepted-id="acceptedIds"
                @update-rejected-id="rejectedIds" :selectedSlave="unmatched_contact.id" :campaignId="campaignId"
                class="searchbox" :key="componentKey" :combined_matches="combined_matches"></Autocomplete> -->
            </div>

            
            <input
            type="checkbox"
            v-model="selected"
            @click="select"
           :value="{ id: unmatched_contact.id}"
          />
          </template>

          <template slot="thead">
            <vs-th>
              Action
            </vs-th>
            <template v-for="(uploadedcol, index) in Object.keys(unmatched_contact)">
              <vs-th>
                <template v-if="unmatched_contact[uploadedcol]">


                  {{ uploadedcol }}
                </template>
              </vs-th>
            </template>
          </template>

          <template slot-scope="{ data }">
            <vs-tr>
              <div class="p-5">
                <vs-button @click="writeMasterDatabaseAndMatch(unmatched_contact)" type="border">Write</vs-button>
              </div>
              <div class="m-5">

                <vs-button @click="dropContactsFromCampaign(unmatched_contact)" type="border"> Drop </vs-button>
              </div>
              <template v-for="(value, index) in Object.values(unmatched_contact)">
                
                <vs-td>
                  <template v-if="value">
                    {{ value }}
                  </template>
                </vs-td>
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </template>
      <vs-pagination :total="total_pages" v-model="currentx" goto></vs-pagination>
    </vx-card>


    <vs-popup fullscreen class="holamundo" title="Add Unmatched Contact To Master DB And Add To Campaign"
      :active.sync="addNewContactsPopUp">

          

      <template v-for="(value,key) in selected_unmatched_contact">


        

        <template v-for="field_array_column in  field_array_columns">
           <template v-if="field_array_column.name == key">


            <template v-if="field_array_column.identifier != 'company_name'">

          

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span
                  :class="{ 'correction_field_class': correction_fields_array.includes(field_array_column.name) }">{{ key }} </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-col sm:w-2/3 w-full">


                  <template v-if="field_array_column.identifier == 'role'">

                    <v-select name="role" class="role" label="role"
                    :options="all_roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_contact[key]" />
                   </template>


                   <template v-else-if="field_array_column.identifier == 'sub_role'">

                    <v-select name="sub_role" class="sub_role" label="sub_role"
                    :options="all_sub_roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_contact[key]" />
                   </template>

                   <template v-else-if="field_array_column.identifier == 'seniority'">

                    <div class="vx-col sm:w-1/3 w-full">
                      <v-select :class="{ 'correction_field_input_class': correction_fields_array.includes('seniority') }"
                        label="seniority" :options="all_seniorities" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_contact[key]" />
                    </div>
                  </template>

                <template v-else-if="field_array_column.identifier == 'ddi_phone_code'">

                  <div class="vx-col sm:w-1/3 w-full">
                    <v-select :class="{ 'correction_field_input_class': correction_fields_array.includes('ddi_phone_code') }"
                      label="phone_code" :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_contact[key]" />
                  </div>
                </template>


                <template v-else-if="field_array_column.identifier == 'mobile_phone_code'">
            
                  <div class="vx-col sm:w-1/3 w-full">
                    <v-select :class="{ 'correction_field_input_class': correction_fields_array.includes('mobile_phone_code') }"
                      label="phone_code" :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_contact[key]" />
                  </div>
                </template>

                



               
                <template v-else>

                  <template v-if="field_array_column.type == 'date'">

<template v-if="correction_fields_array.includes(field_array_column.name)">
                      {{ selected_unmatched_contact[key] }}
                      <br>
                      </template>
      
                                <flat-pickr
                                :class="{ 'correction_field_input_class': correction_fields_array.includes(field_array_column.name) }"
                                  :config="configDatePicker"
                                  placeholder="Choose Date"
                                  :data-vv-as="field_array_column.name"
                                  :name="field_array_column.name" v-validate="field_array_column.mandatory?'required':''"
                                  v-model="selected_unmatched_contact[key]"
                                />
                                  <span class="text-danger text-sm" v-show="errors.has(field_array_column.name)">{{
                    errors.first(field_array_column.name) }}</span>
                              </template>

                                <template v-else-if="field_array_column.type == 'datetime'">

<template v-if="correction_fields_array.includes(field_array_column.name)">
                      {{ selected_unmatched_contact[key] }}
                      <br>
                      </template>
      
                                <flat-pickr
                                :class="{ 'correction_field_input_class': correction_fields_array.includes(field_array_column.name) }"
                                  :config="configDateAndTimePicker"
                                  :data-vv-as="field_array_column.name"
                                  placeholder="Choose Date And Time"
                                  :name="field_array_column.name" v-validate="field_array_column.mandatory?'required':''"
                                  v-model="selected_unmatched_contact[key]"
                                />
                                  <span class="text-danger text-sm" v-show="errors.has(field_array_column.name)">{{
                    errors.first(field_array_column.name) }}</span>
                              </template>

                                  <template v-else-if="field_array_column.type == 'number'">

                                    {{ correction_fields_array.includes(field_array_column.name) ? selected_unmatched_contact[key] : '' }}


                                    <input type="number" 
                                    class="vs-input-class"
                            :class="{ 'correction_field_input_class': correction_fields_array.includes(field_array_column.name) }"
                                    v-model="selected_unmatched_contact[key]" :name="field_array_column.name" v-validate="field_array_column.mandatory?'required':''"
                             :data-vv-as="field_array_column.name" />
      
                             
                                  <span class="text-danger text-sm" v-show="errors.has(field_array_column.name)">{{
                    errors.first(field_array_column.name) }}</span>
                              </template>


                                



 <template v-else>





                <vs-input
                  :class="{ 'correction_field_input_class': correction_fields_array.includes(field_array_column.name) }"
                  class="w-full" v-model="selected_unmatched_contact[key]" :name="field_array_column.name" v-validate="field_array_column.mandatory?'required':''"
                   :data-vv-as="field_array_column.name" />
                   <span class="text-danger text-sm" v-show="errors.has(field_array_column.name)">{{
                    errors.first(field_array_column.name) }}</span> 
             
       </template>
             </template>
                  </div>
      </div>
            </div>

              </template>
           
          
          
          </template>


        </template>








      </template>






    

      <div class="vx-row">
        <div class="vx-col sm:w-2/3 w-full ml-auto">
          <vs-button @click="submitUpdate()" class="mr-3 mb-2">Submit</vs-button>
        </div>
      </div>
    </vs-popup>



    <template v-if="contactExists">
      <vs-popup fullscreen :title="contactDescription.company_name" :active.sync="popupActive">
        <div class="flex justify-between flex-wrap">
          <vs-button class="mb-4 mr-6" @click="accept()" type="border">Accept</vs-button>
          <vs-button class="mb-4" type="border" @click="reject()" color="primary">Reject</vs-button>
        </div>
        <vs-list>
          <vs-list-header title="Key Company Details" color="success"></vs-list-header>
          <vs-list-item title="Company Name ">
            {{ contactDescription.company_name }}
          </vs-list-item>
          <vs-list-item title="Company Registration Number">
            {{ contactDescription.company_registration_number }}
          </vs-list-item>
          <vs-list-item title="Switchboard">
            <template v-for="(ph, index) in contactDescription.phone">
              <div :key="index">
                <template v-for="(ph_type, index2) in ph.phone_type">
                  <div :key="index2" v-if="ph_type.type == 'Switchboard' && ph_type.phone_id == ph.id
                    ">
                    {{ ph.phone_no }}
                  </div>
                </template>
              </div>
            </template>
          </vs-list-item>
          <vs-list-item title="Site Switchboard">
            <template v-for="(ph, index) in contactDescription.phone">
              <div :key="index">
                <template v-for="(ph_type, index2) in ph.phone_type">
                  <div :key="index2" v-if="ph_type.type == 'Site Switchboard' &&
                    ph_type.phone_id == ph.id
                    ">
                    {{ ph.phone_no }}
                  </div>
                </template>
              </div>
            </template>
          </vs-list-item>
        </vs-list>

        <vs-list>
          <vs-list-header title="Address" color="success"></vs-list-header>
          <vs-list-item title="Head Office Address">
            {{ contactDescription.head_office_address_1 }}
            {{ contactDescription.head_office_address_2 }}
            {{ contactDescription.head_office_address_3 }}
            {{ contactDescription.head_office_city }}
            {{ contactDescription.head_office_postcode }}
            {{ contactDescription.head_office_county }}
            {{ contactDescription.head_office_country }}
          </vs-list-item>
          <vs-list-item title="Registered Office Address">
            {{ contactDescription.registered_office_address_1 }}
            {{ contactDescription.registered_office_address_2 }}
            {{ contactDescription.registered_office_address_3 }}
            {{ contactDescription.registered_office_city }}
            {{ contactDescription.registered_office_postcode }}
            {{ contactDescription.registered_office_county }}
            {{ contactDescription.registered_office_country }}
          </vs-list-item>
          <template v-for="(satellite, index) in contactDescription.satellite_office">
            <vs-list-item :title="'Satellite Office ' + (index + 1)" :key="index">
              <template v-for="(phone, index3) in satellite.phone">
                <div :key="index3" v-if="phone.satellite_office_id == satellite.id">
                  {{ phone.phone_no }}
                </div>
              </template>
              {{ satellite.address_1 }}
              {{ satellite.address_2 }}
              {{ satellite.address_3 }}
              {{ satellite.town }}
              {{ satellite.county }}
              {{ satellite.postcode }}

              <template v-for="(country, index2) in satellite.country">
                <div :key="index2" v-if="country.satellite_office_id == satellite.id">
                  {{ country.name_1 }}
                  {{ country.name_2 }}
                  {{ country.name_3 }}
                </div>
              </template>
            </vs-list-item>
          </template>
        </vs-list>

        <vs-list>
          <vs-list-header title="Websites" color="success"></vs-list-header>
          <template v-for="(web, index) in contactDescription.web">
            <div :key="index">
              {{ web.url }}
            </div>
          </template>
        </vs-list>
        <vs-list>
          <vs-list-header title="LinkedIn" color="success"></vs-list-header>
          <template v-for="(linkedin, index) in contactDescription.linkedin">
            <div :key="index">
              {{ linkedin.url }}
            </div>
          </template>
        </vs-list>
      </vs-popup>
    </template>
  </div>
</template>

<script>
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import _ from "lodash";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import UnmatchedContactAutocomplete from "@/components/autocomplete/UnmatchedContactAutocomplete.vue";
import vSelect from "vue-select";
import ContactAutocomplete from "@/components/autocomplete/ContactsAutocomplete.vue";
import ProgressBar from 'vue-simple-progress'
export default {
  components: { UnmatchedContactAutocomplete, "v-select": vSelect, ContactAutocomplete , ProgressBar , flatPickr },
  computed: {
    total_pages () {
      return Math.ceil(this.all_total / this.limit);
    },
    // cloneItems() {
    //     var clone = this.unmatch_contacts;
    //     var startFrom = (this.pagination.page*this.pagination.rowsPerPage)-this.pagination.rowsPerPage;
    //     return clone.splice(startFrom, this.pagination.rowsPerPage);
    // }
  },
  data() {
    return {
                    configDatePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d',
      allowInvalidPreload	: false,
    },
      configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      allowInvalidPreload	: false,
      enableSeconds : true
    },
      PLeasewait: '',
      uploadPercentage: 0,
      all_seniorities : [],
      all_roles : [],
      all_sub_roles : [],
      all_unmatched_contacts : [],
      selected: [],
      allSelected: false,
      all_currency_codes : [],
      all_verticals : [],
      all_sic_codes : [],
      all_countries : [],
      selected_unmatched_contact : {}, 
      mandatory_fields: [],
      all_phone_codes:[],
      selected_fields: null,
      phoneTypes: [],
      selected_registered_office_country: null,
      correction_fields_array: [],
      vertical: null,
      selected_vertical: null,
      correction_fields: null,
      selected_registration_jurisdiction: null,
      currencyCodes: [],
      selected_sic_code: null,
      add_or_update_title: null,
      user_id: null,
      user_role: null,
      selected_head_office_country: null,
      abilities: null,
      field_array_columns: [],
      actual_contact_name:null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      company_category: null,
      sic_code: null,
      revenue: null,
      currency_code: null,
      registration_jurisdiction: null,
      no_of_employees: null,
      // sic_code_description: null,
      phone_type: null,
      phone_no: null,
      ddi_phone_code: null,
      website: null,
      linkedin: null,
      status: null,
      switchboard: null,
      mobile_phone_code: null,
      site_switchboard: null,
      site_mobile_phone_code: null,
      company_name: null,
      selected_fields: null,
      registered_office_country_validation: null,
      EnhancedHeadOfficeAutocompleteComponentKey: 0,
      EnhancedRegOfficeAutocompleteComponentKey: 0,
      EnhancedSicCodeAutocompleteComponentKey: 0,
      EnhancedVerticalAutocompleteComponentKey: 0,
      EnhancedRegistrationJurisdictionAutocompleteComponentKey: 0,
      company_registration_number: null,
      country: null,
      isNewContact: null,
      update_id: null,
      table: null,
      popupActive: false,
      updateData: [],
      currency_code_validation: null,
      currencyCodes: [],
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      contactDescription: {},
      contactExists: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      headOfficeIsRegisteredOffice: false,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_company_registration_number: null,
      contacts: {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        sicCodeWithDescription: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null
      },
      contactDescription: {},
      addNewContactsPopUp: false,
      campaignDescription: [],
      export_link: null,
      enrich_contact_to_master_db_link: null,
      abilities: null,
      campaignId: null,
      componentKey: 0,
      limit: 10,
      currentx: 1,
      paginate: { limit: 10, offset: 0 },
      tableData: [],
      header: [],
      sheetName: "",
      list2: [],
      uploaded_columns: [],
      selected_fields: [
        "ml_company",
        "ml_actual_contact_name",
        [
          [
            "Head Office Address",
            "Registered Office",
            "State",
            "Town",
            "Country",
            "Postal Code",
            "Site Office"
          ]
        ]
      ],
      unmatch_contacts: [],
      accept_text: "Accept",
      acceptButtonColor: "primary",
      accepted_matches: [],
      combined_matches: [],
      all_total : 0
    };
  },
  mounted() {
    this.getSelectedMandatoryFields();
    this.unmatchedData();
    this.getCampaignDescription();
    this.getAllRoles();
    this.getAllSeniority();
    this.getAllPhoneCodes()
    this.export_link = "/contacts/remain_unmatched/" + this.campaignId;
    this.enrich_contact_to_master_db_link =
      "/contacts/enrichContactDataToMasterDb/" + this.campaignId;
  },
  watch: {
    "selected_unmatched_contact.Role"(val) {
      if (val) {
        this.getAllSubRole(val.id);
      }
    },
    currentx: function (val, oldVal) {
      this.unmatch_contacts = this.all_unmatched_contacts.slice((val - 1) *  this.limit, val * this.limit);
    }
  },
  methods: {
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("accountsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_phone_codes.forEach(function(ele){
            if(ele.phone_code){
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })

          
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    selectAll() {

    


// this.$vs.loading();






// let matches = this.unmatch_contacts;



var matches = [...this.unmatch_contacts, ...this.all_unmatched_contacts];



if (this.allSelected) {
  matches.forEach(match => {
    this.selected.pop({ id: match.id});
  });
} else {

  

  
  // this.allSelected = false;
  matches.forEach(match => {
    this.selected.push({ id: match.id });
  });
  // this.match_ten_context.map(
  //   function(ele) {
  //     if (ele.page == this.currentx) {
  //       return (ele.ten_selected = true);
  //     }
  //   }.bind(this)
  // );
}

this.selected = this.removeDuplicates(this.selected, "id");


// this.$vs.loading.close();

},
select() {
this.allSelected = false;

// this.match_ten_context.map(
//   function(ele) {
//     if (ele.page == this.currentx) {
//       return (ele.ten_selected = false);
//     }
//   }.bind(this)
// );
},
    getSelectedMandatoryFields() {
      let self = this;
      let selected_campaign_id = self.$route.params.campaignId
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedMandatoryFields",
          selected_campaign_id
        )
        .then(response => {
          let result = JSON.parse(response.data);

          if (result.length != 0) {


          self.mandatory_fields = result.filter(ele => ele.level == 'contact' || ele.level == 'opportunity' );





          }

        })
        .catch(err => {
          if (err) {

            console.log(err)
            return;
          }
          console.error(err);
        });
    },
    campaignDataOptions(){




     let self  = this
      // let data = {}
      // data.campaignId = this.campaignId
      // axios
      //   .post(
      //     this.$base_url + "/api/contacts/update_master_db_flag",
      //     data
      //   )
      //   .then(response => {
          
        
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });

        self.$router
              .push(
                "/contacts/optionsAfterImportContactToCampaign/" +
                self.campaignId
              )
    


      // this.checkDuplicateExists();
    },

    submitUpdate() {


      this.$validator.validateAll().then(result => {
        if (result) {


          this.selected_unmatched_contact.campaignId = this.$route.params.campaignId;
          this.selected_unmatched_contact.is_new_contact = "Y"

          this.$store
            .dispatch(
              "contactsManagement/addContactAndAddToCampaign",
              this.selected_unmatched_contact
            )
            .then(response => {

              this.addNewContactsPopUp = false;


              if (response.data == "account_not_exists") {

                this.$vs.dialog({
                  color: "primary",
                  title: `Account Not Exists`,
                  text:
                    "Account doesn't exist.Please update it and submit again",
                  accept: this.addNewContactsPopUp
                });
               }
               else if (response.data == "required_correction") {
                this.$vs.dialog({
                  color: "primary",
                  title: `Required Correction`,
                  text:
                    "The fields with red title should be corrected. Please update it and submit again",
                  accept: this.addNewContactsPopUp
                });
               }
                else if (response.data == "error") {

 this.$vs.notify({
                  color: "danger",
                  title: "Contact Not Added",
                  text: "Something went wrong. Please contact administrator"
                });


}
              
              
              else {

                this.$vs.notify({
                  color: "success",
                  title: "Contact Added",
                  text: "The contact was added successfully"
                });


              }

               this.unmatchedData()
              this.$router.go(0);

              // this.unmatchedData()



            })
            .catch(error => {
              console.log(error);
            });
        }

      })



    },

    acceptAlert() {
      this.addNewContactsPopUp = true;




    },
    addContactAndAddToCampaign() {



      this.$store
        .dispatch(
          "contactsManagement/addContactAndAddToCampaign",
          this.contactDescription
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.addNewContactsPopUp = false;

            this.$vs.notify({
              color: "success",
              title: "Contact Exists",
              text: res.data.message
            });
            this.addNewContactsPopUp = true;

            // return false
          } else {
            this.$vs.notify({
              color: "success",
              title: "Contact Added",
              text: "The contact was added successfully"
            });
            this.unmatchedData();
            this.addNewContactsPopUp = false;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    writeMasterDatabaseAndMatch(data) {
      this.correction_fields_array = []
      this.isNewContact = "Y";
      this.add_or_update_title = "Please update the field and submit"
     

      if (data.correction_fields != null && data.correction_fields != '') {
        this.correction_fields_array = JSON.parse(data.correction_fields)
      }

      this.selected_unmatched_contact = data;
      this.selected_unmatched_contact.id = data.id


      this.addNewContactsPopUp = true;
    },
    dropContactsFromCampaign(data) {
      this.contactDescription = data;
      this.contactDescription.campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch(
          "contactsManagement/dropContactsFromCampaign",
          this.contactDescription
        )
        .then(res => {
          if (res) {
            this.$vs.notify({
              color: "success",
              title: "Contact",
              text: "The contact was removed successfully"
            });
            this.unmatchedData();
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    forceRerender() {
      this.componentKey += 1;
    },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
    acceptedIds(ids) {
      let self = this;
      ids.forEach(function (ie) {
        self.combined_matches.push(ie);
        self.combined_matches.map(function (ce) {
          if (ie.slave_id == ce.slave_id) {
            return (ce.uuid = ie.master_id);
          }
        });
        self.combined_matches = self.combined_matches.filter(
          (v, i, a) => a.findIndex(t => t.slave_id === v.slave_id) === i
        );

        self.combined_matches = self.combined_matches.map(function (ele) {
        ele.campaignId = self.campaignId;
        return ele;
      });



      axios
        .post(
          self.$base_url + "/api/contacts/save_unmatched_contacts",
          self.combined_matches
        )
        .then(response => {

          if (response.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Contact Matched",
              text: "The contact was matched successfully"
            });

            self.componentKey += 1;
          }

          self.unmatchedData();

      



        })
        .catch(error => {
          console.log(error);
        });









      });
    },
    rejectedIds(ids) {
      let self = this;
      self.combined_matches = self.combined_matches.filter(function (ele) {
        return ele.slave_id != ids[0].slave_id;
      });
    },
    goBack: function () {
      this.$router.go(-1);
    },
    acceptSelected() {
      
      let self = this
      // self.$vs.loading()
      self.writeSelectedContactToMasterDB()
        // self.$vs.loading.close();

        

    },
   updateMasterdbFlag(){

      

        let self = this

        self.$vs.notify({
          color: "primary",
          title: "Update Master DB",
          text: "Please wait while the master db is being updated with matched excel contacts.This may take a few minutes",
        });

        self.$vs.loading()



      let data = {}
            data.campaignId = self.$route.params.campaignId;
            axios
              .post(
                self.$base_url + "/api/contacts/update_master_db_flag",
                data
              )
              .then(response => {
                if (response.data.status == "success") {
                  // console.log("Master DB Flag Updated Successfully");
                  self.$vs.loading.close();

                  self.$router
                    .push(
                      "/contacts/enrichContactDataToMasterDb/" +
                      self.$route.params.campaignId
                    )
             


                  


                } else {
                  self.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: "Something went wrong. Please try again"
                  });
                }






                
                
              
              })
              .catch(error => {
                console.log(error);
              });

              self.$vs.loading.close();



    },
    writeSelectedContactToMasterDB() {


      
      let self = this
      this.PLeasewait = "Please wait while the data is being written to the master database.This may take a few minutes"
      // this.selected = this.removeDuplicates(this.selected, "id");



      let selected_data = {};
      selected_data.selected_contacts = this.selected;
      selected_data.campaignId =  this.$route.params.campaignId






      axios
        .post(
          this.$base_url + "/api/contacts/write_selected_contact_to_masterdb",
          selected_data , 
          {
            onDownloadProgress: function( progressEvent ) {

  
              let progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );
              
  
              if( progress == 100 ) {
                this.uploadPercentage = 100

                              }
                  
                  
                        }.bind(this),
                        onUploadProgress: function( progressEvent ) {

                  
                    
                          let progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );


                if( progress == 100 ) {
                  this.uploadPercentage = 50

                }


                }.bind(this)
          }).then(response => {

          
          let no_of_issues = response.data.data.no_of_issues
            let no_of_added_contact = response.data.data.no_of_added_contact
          

          if (response.data.status == "success") {

            self.$vs.loading.close();
            

  


            if (no_of_issues == 0) {

            

            


             self.updateMasterdbFlag()
              
            }
            else{

            

            this.$vs.dialog({
              color: "primary",
              title: `Import Contact To Campaign`,
              text: no_of_added_contact + " contacts were successfully added to the campaign.  However, " + no_of_issues + " selected contacts have issues.  Please resolve these before proceeding.",
              accept: this.finished
            });

            }

           


           





            
           
          }
      


          
        })
        .catch(error => {
          console.log(error);
        });
    },
    finished() {
      this.selected = []
      this.allSelected = false
      // this.unmatchedData()
       location.reload();

    },
    // checkDuplicateExists() {
    //   let self = this;
    //   self.paginate.campaignId = self.campaignId;
    //   axios
    //     .post(
    //       this.$base_url + "/api/contacts/deduplicate_csv_contacts_data",
    //       self.paginate
    //     )
    //     .then(response => {
    //       let result = JSON.parse(response.data);

    //       if (result.length == 0) {

    //         self.$router
    //           .push(
    //             "/contacts/optionsAfterImportContactToCampaign/" +
    //             self.campaignId
    //           )
    //           .catch(() => { });
    //           this.$vs.loading.close();

           
    //       } else {
    //         this.deduplicateOldNewCSV();
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    updateOtherFieldDataToMasterDb() {
    let self = this

    self.$vs.dialog({
        color: "primary",
        title: `Import None Core Fields`,
        text: "You are about to import non-core fields to the database.  After you click accept this process will start.  You will receive an email once this process has completed. ",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      let self = this
      let data = {};
      data.campaign_id = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/contacts/update_other_field_to_masterdb_from_csv_table",
          data
        )
        .then(response => {
          if (response.data.status == "success") {


         self.sendCompletedEmail()
            

          

            console.log("Updated other field data to master db")
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    sendCompletedEmail(){
       let self = this
        let data = {}
        data.user_id = self.user_id
        data.message = "Import None Core Fields has been completed."
        data.subject = "Import None Core Fields"
        axios
        .post(
          self.$base_url + "/api/contacts/send_completed_email",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Import None Core Fields",
              text: "The email has been sent"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
        
    },
    unmatchedData() {
      let self = this
      this.$vs.loading();
      let data = {};
      data.campaignId = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/contacts/get_unmatched_contacts",
          data
        )
        .then(response => {
          let response_data = JSON.parse(response.data)

           if (response_data.rows.length == 0) {

            console.log("No unmatched contacts found");

           self.updateMasterdbFlag()


           
          }else{

        

              this.unmatch_contacts = response_data.rows.slice((this.currentx - 1) *  this.limit, this.currentx * this.limit);


          this.all_unmatched_contacts = response_data.rows


          let total = response_data.total_pages;
          this.all_total = total;





          this.field_array_columns =response_data.campaign_table_data

          this.field_array_columns.forEach(function(ele){
            ele.mandatory = false

            self.mandatory_fields.forEach(function(mandatory){


              if(ele.name == mandatory.name){
                ele.mandatory = true
              }

            })

          })



          this.$vs.loading.close();




        }


        
        })
        .catch(error => {
          console.log(error);
        });
    },
    getAllSeniority() {
      this.$store
        .dispatch("contactsManagement/getSeniority")
        .then(res => {
          this.all_seniorities = res.data;
          console.log(this.contacts.seniorities);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getAllRoles() {
      this.$store
        .dispatch("contactsManagement/getRoles")
        .then(res => {
          this.all_roles = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getAllSubRole(role_id) {
      this.$store
        .dispatch("contactsManagement/getSubRoles", role_id)
        .then(res => {
          this.all_sub_roles = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.searchbox {
  padding: 10px 21px;
  width: 600px;
}

.relative {
  /* position: fixed !important; */
  z-index: 999;
  /* width: 98.5%; */
}

.vxtable {
  /* position: absolute !important; */
  margin-top: 20px;
}

.correction_field_class {
  color: red;
}

.correction_field_input_class {
  border: 1px solid red;
}
</style>
